import { Creators } from './actions';

export const setLanguage = Creators.setLanguage;
export const setCurrency = Creators.setCurrency;
export const setRequests = Creators.setRequests;
